var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content-wrapper" },
    [
      _c("h3", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("tables.tables"))),
      ]),
      _vm._v(" "),
      _vm.hasTableInClipboard
        ? _c("div", { staticClass: "paste-info-message" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("content_paste"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.pasteInfoDetected")))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "table-wrapper" }, [
        _c("div", { staticClass: "toolbar" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c("a-input-search", {
                staticClass: "search-input",
                staticStyle: { width: "300px", margin: "unset !important" },
                attrs: { placeholder: _vm.$t("message.search") },
                on: { input: _vm.onSearch },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.create"] } },
                [
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "toolbar-btn category-btn",
                      attrs: { ghost: "" },
                      on: { click: _vm.performShowCreateCategoryModal },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("category"),
                      ]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("tables.addCategory")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "toolbar-btn new-table-button",
                      attrs: { primary: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$feature.beforeCreateTable(_vm.createTable)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.newTable")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "toolbar-btn ai-button",
                      attrs: { ghost: "" },
                      on: { click: _vm.showWizard },
                    },
                    [
                      _c("img", {
                        staticClass: "copilot-icon",
                        attrs: { src: "/static/img/copilot.png" },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("tables.createAppWithSupsisAssistant")
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "categories-container" },
          _vm._l(_vm.categorizedTables, function (category) {
            return _c(
              "div",
              {
                key: category.name,
                staticClass: "category-section",
                class: { "drag-over": _vm.dragOverCategory === category.name },
                on: {
                  drop: function ($event) {
                    return _vm.onDrop($event, category.name)
                  },
                  dragover: function ($event) {
                    return _vm.allowDrop($event, category.name)
                  },
                  dragleave: _vm.onDragLeave,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "category-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleCategory(category.name)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "category-info" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            staticClass: "collapse-toggle",
                            attrs: { ghost: "", small: "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleCategory(category.name)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.categoryExpandStates[category.name] !==
                                      false
                                      ? "expand_less"
                                      : "expand_more"
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        category.icon
                          ? _c(
                              "i",
                              { staticClass: "material-icons category-icon" },
                              [_vm._v(_vm._s(category.icon))]
                            )
                          : _c(
                              "i",
                              { staticClass: "material-icons category-icon" },
                              [_vm._v("folder")]
                            ),
                        _vm._v(" "),
                        _c("span", { staticClass: "category-name" }, [
                          _vm._v(
                            _vm._s(_vm.formatCategoryLabel(category.name))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "table-count" }, [
                          _vm._v("(" + _vm._s(category.tables.length) + ")"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-actions" },
                      [
                        !_vm.isDefaultTableCategory(category.name)
                          ? _c("SupsisButton", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t("tables.editCategory"),
                                  },
                                  expression:
                                    "{ content: $t('tables.editCategory') }",
                                },
                              ],
                              attrs: { ghost: "", icon: "edit", small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.editCategory(category)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isDefaultTableCategory(category.name)
                          ? _c("SupsisButton", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.$t("tables.deleteCategory"),
                                  },
                                  expression:
                                    "{ content: $t('tables.deleteCategory') }",
                                },
                              ],
                              attrs: {
                                ghost: "",
                                icon: "delete",
                                small: "",
                                danger: "",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteCategory(category.name)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        category.tables.length > 0
                          ? _c(
                              "a-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  placement: "bottomRight",
                                  overlayClassName: "category-actions-dropdown",
                                  visible:
                                    _vm.categoryDropdownStates[category.name],
                                },
                                on: {
                                  visibleChange: function (visible) {
                                    _vm.$set(
                                      _vm.categoryDropdownStates,
                                      category.name,
                                      visible
                                    )
                                  },
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-menu-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu-item submenu-item",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("drive_file_move")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("tables.moveAllTables")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons submenu-arrow",
                                            },
                                            [_vm._v("chevron_left")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "submenu-content" },
                                            _vm._l(
                                              _vm.availableCategoriesForCategory(
                                                category.name
                                              ),
                                              function (targetCategory) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: targetCategory.name,
                                                    staticClass:
                                                      "submenu-item-content",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.moveAllTablesToCategory(
                                                          category.name,
                                                          targetCategory.name
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    targetCategory.icon
                                                      ? _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                targetCategory.icon
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons",
                                                          },
                                                          [_vm._v("folder")]
                                                        ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatCategoryLabel(
                                                            targetCategory.name
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("SupsisButton", {
                                  staticClass: "category-more-actions-btn",
                                  attrs: {
                                    ghost: "",
                                    icon: "more_vert",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.categoryExpandStates[category.name] !== false,
                        expression:
                          "categoryExpandStates[category.name] !== false",
                      },
                    ],
                    staticClass: "tables-grid",
                    class: {
                      collapsed:
                        _vm.categoryExpandStates[category.name] === false,
                    },
                  },
                  [
                    category.tables.length === 0
                      ? _c("div", { staticClass: "empty-category-message" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("drag_handle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("tables.dragTablesToCategory"))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(category.tables, function (table) {
                      return _c(
                        "div",
                        {
                          key: table._id,
                          staticClass: "table-card",
                          class: {
                            dragging:
                              _vm.draggedTable &&
                              _vm.draggedTable._id === table._id,
                          },
                          attrs: { draggable: "true" },
                          on: {
                            dragstart: function ($event) {
                              return _vm.onDragStart($event, table)
                            },
                            dragend: _vm.onDragEnd,
                          },
                        },
                        [
                          _c("div", { staticClass: "table-card-header" }, [
                            _c(
                              "a",
                              {
                                staticClass: "table-name",
                                attrs: { href: _vm.getTableHref(table._id) },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleTableClick(
                                      table._id,
                                      $event
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(table.name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "table-actions" },
                              [
                                _c("SupsisButton", {
                                  staticClass: "view-btn",
                                  attrs: {
                                    component: "a",
                                    href: _vm.getTableHref(table._id),
                                    ghost: "",
                                    icon: "visibility",
                                    small: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTableClick(
                                        table._id,
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _vm.canEditTableMeta(table)
                                      ? _c("SupsisButton", {
                                          staticClass: "edit-btn",
                                          attrs: {
                                            ghost: "",
                                            icon: "edit",
                                            small: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editTable(table._id)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.delete"] } },
                                  [
                                    _c("SupsisButton", {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            content: table.deleteProtection
                                              ? _vm.$t(
                                                  "tables.deleteProtectionActive"
                                                )
                                              : "",
                                          },
                                          expression:
                                            "{\n                                            content: table.deleteProtection ? $t('tables.deleteProtectionActive') : '',\n                                        }",
                                        },
                                      ],
                                      attrs: {
                                        danger: "",
                                        ghost: "",
                                        icon: "delete",
                                        small: "",
                                        disabled: table.deleteProtection,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteTable(table._id)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-popover",
                                  {
                                    attrs: {
                                      trigger: "click",
                                      placement: "bottomRight",
                                      overlayClassName:
                                        "table-actions-dropdown",
                                      visible: _vm.dropdownStates[table._id],
                                    },
                                    on: {
                                      visibleChange: function (visible) {
                                        _vm.$set(
                                          _vm.dropdownStates,
                                          table._id,
                                          visible
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-menu-content",
                                        },
                                        [
                                          _vm.canAccessTable(table)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.duplicateTable(
                                                        table
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("content_copy")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tables.copyTable"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canAccessTable(table)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyTableAsJSON(
                                                        table
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("file_copy")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tables.copyAsJSON"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canEditTableMeta(table)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item submenu-item",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("drive_file_move")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tables.changeCategory"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons submenu-arrow",
                                                    },
                                                    [_vm._v("chevron_left")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "submenu-content",
                                                    },
                                                    _vm._l(
                                                      _vm.availableCategoriesForTable(
                                                        table
                                                      ),
                                                      function (
                                                        categoryOption
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: categoryOption.name,
                                                            staticClass:
                                                              "submenu-item-content",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.moveTableToCategory(
                                                                  table,
                                                                  categoryOption.name
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            categoryOption.icon
                                                              ? _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        categoryOption.icon
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "folder"
                                                                    ),
                                                                  ]
                                                                ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCategoryLabel(
                                                                    categoryOption.name
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canEditTableMeta(table)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleDeleteProtection(
                                                        table
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            table.deleteProtection
                                                              ? "lock_open"
                                                              : "lock"
                                                          ) +
                                                          "\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          table.deleteProtection
                                                            ? _vm.$t(
                                                                "tables.turnOffDeleteProtection"
                                                              )
                                                            : _vm.$t(
                                                                "tables.turnOnDeleteProtection"
                                                              )
                                                        ) +
                                                        "\n                                                "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.canShowPermissionSettings(table)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goToPermissionSettings(
                                                        table
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "admin_panel_settings"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tables.privacySettings"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("SupsisButton", {
                                      staticClass: "more-actions-btn",
                                      attrs: {
                                        ghost: "",
                                        icon: "more_vert",
                                        small: "",
                                      },
                                    }),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          table.description
                            ? _c("div", { staticClass: "table-description" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(table.description) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "table-meta" }, [
                            table.createdByUser
                              ? _c(
                                  "div",
                                  { staticClass: "created-by" },
                                  [
                                    _c("Avatar", {
                                      attrs: {
                                        size: 20,
                                        src: _vm.users[table.createdByUser._id]
                                          ? _vm.users[table.createdByUser._id]
                                              .gravatar
                                          : null,
                                        username: _vm.users[
                                          table.createdByUser._id
                                        ]
                                          ? _vm.users[table.createdByUser._id]
                                              .name
                                          : "Sistem",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.users[table.createdByUser._id]
                                            ? _vm.users[table.createdByUser._id]
                                                .name
                                            : "Sistem"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "created-date" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm
                                      .$moment(table.createdAt)
                                      .format("DD.MM.YYYY")
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.showCreateModal
        ? _c(
            "Modal2",
            {
              attrs: { showFooter: false, title: _vm.$t("tables.createTable") },
              on: {
                cancel: function ($event) {
                  _vm.showCreateModal = false
                },
              },
            },
            [
              _c("CreateTable", {
                on: {
                  create: _vm.handleCreateTable,
                  "navigate-to-templates": _vm.onNavigateToTemplates,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditModal
        ? _c(
            "Modal2",
            {
              attrs: { showFooter: false, title: _vm.$t("tables.editTable") },
              on: {
                cancel: function ($event) {
                  _vm.showEditModal = false
                },
              },
            },
            [
              _c("EditTable", {
                attrs: { table: _vm.editingTable },
                on: { update: _vm.handleUpdateTable },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateCategoryModal || _vm.showEditCategoryModal
        ? _c(
            "Modal2",
            {
              attrs: {
                showFooter: false,
                title: _vm.editingCategory
                  ? _vm.$t("tables.editCategory")
                  : _vm.$t("tables.addCategory"),
              },
              on: { cancel: _vm.closeCategoryModal },
            },
            [
              _c("div", { staticClass: "table-category-form" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("tables.categoryName"))),
                    ]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("tables.categoryNamePlaceholder"),
                      },
                      model: {
                        value: _vm.categoryForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.categoryForm, "name", $$v)
                        },
                        expression: "categoryForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("İkon")]),
                    _vm._v(" "),
                    _c("MaterialIconPicker", {
                      model: {
                        value: _vm.categoryForm.icon,
                        callback: function ($$v) {
                          _vm.$set(_vm.categoryForm, "icon", $$v)
                        },
                        expression: "categoryForm.icon",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions d-flex gap-5 flex-end" },
                  [
                    _c(
                      "SupsisButton",
                      { on: { click: _vm.closeCategoryModal } },
                      [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.saveCategory },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.editingCategory
                                ? _vm.$t("tables.categoryUpdate")
                                : _vm.$t("tables.categoryCreate")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTableAiWizard
        ? _c("TableAiWizard", {
            on: {
              "table-added": _vm.tableAdded,
              close: function ($event) {
                _vm.showTableAiWizard = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }